<h2 mat-dialog-title>
  <span class="groupIcon">
    <mat-icon>group_add</mat-icon>
  </span>
  Select & Add Participants
  <button mat-icon-button (click)="closeAll()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="mat-typography">

  <div class="signaturePanel">

    <div class="esign">
      <div class="panel" *ngIf="participantMessageInfo!=null">
        <div class="example-list">
        </div>
        <!-- <div class="groupHolder">
          <div cdkDropList class="example-list">
            <div class="groupheading" (click)="getToogleInformation()">
              <h2>
                <mat-icon>message</mat-icon>Information
              </h2>
              <button mat-icon-button> <mat-icon>expand_more</mat-icon> </button>
            </div>

            <div id="participantMessageDiv" [ngClass]="{'active' : toogleInformation}"
              innerHtml="{{participantMessageInfo}}"></div>

          </div>
        </div> -->
      </div>
      <div class="panel" cdkDropListGroup>

        <!-- <mat-form-field class="" appearance="fill">
          <mat-label>Project</mat-label>
          <input matInput placeholder="Enter project name" value="">
        </mat-form-field> -->

        <div class="groupHolder" *ngFor="let p1 of projectGroups">

          <div cdkDropList id="{{p1.groupName}}" [cdkDropListData]="p1.projGrpRelationParticipantList"
            class="example-list">

            <div class="groupheading">
              <h2 *ngIf="p1.groupType ==1">
                <mat-icon>create</mat-icon>{{p1.groupName}}
              </h2>

              <h2 *ngIf="p1.groupType !=1">
                <mat-icon>description</mat-icon>{{p1.groupName}}
              </h2>

            </div>

            <div *ngIf="p1.projGrpRelationParticipantList.length == 0" class="moveblock example-box">
              <p class="nocontent">No relationship added</p>
            </div>

            <div *ngFor="let p of p1.projGrpRelationParticipantList" class="moveblock example-box" cdkDrag>

              <div class="DragIcon" cdkDragHandle>
                <mat-icon>drag_indicator</mat-icon>
              </div>

              <div class="Colrd" [ngStyle]="{'background-color': p.colourCode }">
                <mat-icon *ngIf="p.typeOfParticipant==0">email</mat-icon>
                <mat-icon *ngIf="p.typeOfParticipant==4">person</mat-icon>
                <mat-icon *ngIf="p.typeOfParticipant==5">work</mat-icon>
                <mat-icon *ngIf="p.typeOfParticipant==1">app_registration</mat-icon>
                <mat-icon *ngIf="p.typeOfParticipant==2">contact_mail</mat-icon>
                <mat-icon *ngIf="p.typeOfParticipant==3">business</mat-icon>
              </div>

              <div class="userInfo">
                <div class="chipss">
                  <mat-chip-list>
                    <mat-chip> {{p.relationName}} </mat-chip>
                  </mat-chip-list>
                </div>


                <div class="selectContact" *ngIf="p.participantName || p.roleName || p.contactEmail">
                  <div class="userpic" *ngIf="p.participantImageURL">
                    <img [src]="p.participantImageURL" alt="" />
                  </div>

                  <div class="userpic" *ngIf="!p.participantImageURL">
                    <span class="shortName" *ngIf="p.participantName">{{getShortName(p.participantName)}}</span>
                    <span class="shortName" *ngIf="p.roleName">{{getShortName(p.roleName)}}</span>
                    <span class="shortName" *ngIf="p.contactEmail">{{getShortName(p.contactEmail)}}</span>
                  </div>

                  <div class="info">
                    <p *ngIf="p.participantName">{{ p.participantName }} </p>

                    <p *ngIf="p.roleName">{{ p.roleName }} </p>
                    <p *ngIf="p.typeOfParticipant==0">{{p.contactEmail}}</p>
                    <p class="emailID" *ngIf="p.typeOfParticipant!=0">{{ p.participantEmail }} </p>
                  </div>


                  <button class="removeContact" mat-icon-button color="basic" (click)="RemoveRelation(p,p1)">
                    <mat-icon>close</mat-icon>
                  </button>

                </div>

                <ng-container *ngIf="!p.participantName && !p.roleName &&  !p.contactEmail">
                  <button mat-icon-button color="primary" class="personadd"
                      (click)="assignUserNew(true,false,'',p,p1)">
                      <mat-icon>person_add</mat-icon>
                    </button>
                  <!-- <button mat-icon-button color="primary" class="personadd"
                    (click)="assignUser(addAssigne,true,false,'',p,p1)">
                    <mat-icon>person_add</mat-icon>
                  </button> -->
                </ng-container>



              </div>
              <ng-container *ngIf="p.selectedContactFieldEmailID!=null">
                <div class="partdrop">
                  <mat-form-field>
                    <mat-label>Select {{ContactNames}}</mat-label>
                    <mat-select (selectionChange)="onSelectContact($event,p.relationName,p,p1)">
                      <mat-option *ngFor="let role of p.selectedContactFieldEmailID" [value]="role.name">
                        {{role.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

              </ng-container>

            </div>


          </div>

        </div>

      </div>
    </div>

  </div>

</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="basic" (click)="closeAll()">Cancel</button>
  <span>
    <button mat-stroked-button color="primary" (click)="openProject()">Edit</button>
    <button mat-flat-button color="primary" [disabled]="!SendButtonDisabled" (click)="ProjectSend()">Send</button>
  </span>
</mat-dialog-actions>


<ng-template #addAssigne>

  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span>
    Select & Add Participant
    <button mat-icon-button (click)="closeAssign()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
 
  <mat-dialog-content class="mat-typography">
    <div class="radOpts">
      <mat-radio-group aria-label="Select an option" color="primary">
        <mat-radio-button value="1" [checked]=true (click)="selectSharedAccessRb(1)">{{contactNames}}</mat-radio-button>
        <mat-radio-button value="2" (click)="selectSharedAccessRb(2)">Role</mat-radio-button>
        <mat-radio-button *ngIf="coreNames!=''" value="3" (click)="selectSharedAccessRb(3)">{{coreNames}}</mat-radio-button>
        <mat-radio-button value="4" (click)="selectSharedAccessRb(4)">User</mat-radio-button>
      </mat-radio-group>
    </div>
    <ng-container *ngIf="showContact==true && peoples.length==0">
      <app-contactlist *ngIf="!isSharedAccessRolePopup" [objectList]="contactsList"
        [isSharedAccessRolePopup]="isSharedAccessRolePopup" [isRolePopup]="isRolePopup"
        (NotifyItemSelected)="contactSelected($event)" (NotifyListfetch)="getContactListCoreImplementation($event)"
        (keydown.enter)="onEnter($event)">
      </app-contactlist>
    </ng-container>

    <ng-container *ngIf="showRole==true && selectedsharedAccessRole.length==0">
      <app-contactlist *ngIf="isSharedAccessRolePopup" [objectList]="sharedAccessRoleList"
        [isSharedAccessRolePopup]="isSharedAccessRolePopup" [isRolePopup]="isRolePopup"
        (NotifyItemSelected)="RoleSelectedForSharedAccess($event)" (NotifyListfetch)="getSharedAccessRoles($event)"
        >
      </app-contactlist>
    </ng-container>

    <app-contactlist *ngIf="isSharedAccessUserPopup" [objectList]="sharedAccessUserList" [isReviewerPopup]="isSharedAccessUserPopup" [isRolePopup]="isRolePopup" (NotifyItemSelected)="userSelected($event)" (NotifyListfetch)="getUserListCoreImplementation($event)"></app-contactlist>
    
    
    <ng-container *ngIf="showSearchCore==true && selectCoreList.length==0">
      <mat-form-field  appearance="fill">
        <input matInput placeholder="Search {{coreNames}}" [formControl]="stateCtrl"
          (input)="searchCore($event.target.value)" [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option  (click)="coreSelected(core)" 
             *ngFor="let core of attachedToCoreList" [value]="core.name">
              <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                  <div class="userpic">
                      <img *ngIf="core.imageUrl!=''" src="{{core.imageUrl}}" alt="">
                      <span class="username" *ngIf="core.imageUrl==''" class="username">
                          {{core.shortName}}
                        </span>
                  </div>
                  <div class="info">
                    <p> {{ core.name }}</p>
                    <p class="email">{{ core.email }}</p>
                  </div> 
              </span>
            </mat-option>
          </mat-autocomplete>
      </mat-form-field>
    </ng-container>

    <ul *ngIf="!isSharedAccessRolePopup" class="selectedlist">
      <li *ngFor="let user of peoples">
        <div class="userndetail">
          <div class="userpic">
            <img *ngIf="user.img!=''" src="{{user.img}}" alt="">
            <span *ngIf="user.img==''" class="username">
              {{user.shortName}}
            </span>
          </div>
          <div class="detail">
            <h4>{{user.name}}</h4>
            <p>{{user.email}}</p>
          </div>
          <div class="opt">
            <button mat-icon-button>
              <mat-icon (click)="removeItem(user,isRolePopup)">cancel</mat-icon>
            </button>
          </div>
        </div>
      </li>
    </ul>

    <ul *ngIf="isSharedAccessRolePopup" class="selectedlist">
      <li *ngFor="let role of selectedsharedAccessRole">
        <div class="userndetail">
          <div class="detail">
            <h4> {{role.name}}</h4>
          </div>
          <div class="opt">
            <button mat-icon-button>
              <mat-icon (click)="removeItemRoleParticipant(role,isSharedAccessRolePopup)">cancel</mat-icon>
            </button>
          </div>
        </div>
      </li>
    </ul>

    <ul *ngIf="selectCoreList.length>0" class="selectedlist">
      <li *ngFor="let user of selectCoreList">
        <div class="userndetail">
          <div class="userpic">
            <img *ngIf="user.img!=''" src="{{user.img}}" alt="">
            <span *ngIf="user.img==''" class="username">
              {{user.shortName}}
            </span>
          </div>
          <div class="detail">
            <h4>{{user.name}}</h4>
            <p>{{user.email}}</p>
          </div>
          <div class="opt">
            <button mat-icon-button>
              <mat-icon (click)="removeCore(user)">cancel</mat-icon>
            </button>
          </div>
        </div>
      </li>
    </ul>
    
    <ul *ngIf="userSelectedList.length>0" class="selectedlist">
      <li *ngFor="let user of userSelectedList">
        <div class="userndetail">
            <!-- <div class="userpic">
              <img *ngIf="user.img!=''" src="{{user.img}}" alt="">
              <span *ngIf="user.img==''" class="username">
                  {{user.shortName}}
                </span>
            </div> -->
            <div class="detail">
                <h4>{{user.name}}</h4>
                <p>{{user.email}}</p>
            </div>
            <div class="opt">
                <button mat-icon-button><mat-icon (click)="removeUser(user)">cancel</mat-icon></button>
            </div>
        </div>
      </li>
    </ul>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="closeAssign()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]=!showAddButton (click)="addUpdateParticipants()">Done</button>
  </mat-dialog-actions>
</ng-template>





